import { Button, Dialog, DialogContentText, Stack, Skeleton, Typography } from '@mui/material';
import { useTheme } from '@mui/system';
import React, { useEffect, useState } from 'react';
import Confetti from 'react-dom-confetti';
import CongratsModalBG from 'url:../../../../assets/CongratsModalBG.png';
import { useGetPacksSummaryQuery } from '../../../api/packSlice';

function CompleteModal(props) {
    const theme = useTheme();
    const [confettiActive, setConfettiActive] = useState(false);
    const { data: summary, isLoading: isLoadingSummary, refetch } = useGetPacksSummaryQuery(props.physicianId);

    const confettiConfig = {
        angle: 90,
        spread: 360,
        startVelocity: '30',
        elementCount: '500',
        dragFriction: 0.12,
        duration: '3000',
        stagger: '0',
        width: '10px',
        height: '10px',
        perspective: '500px',
        colors: ['#a864fd', '#29cdff', '#78ff44', '#ff718d', '#fdff6a']
    };

    function handleCloseModal() {
        props.setOpen(false);
    }

    // Activate confetti and refetch summary every time the modal opens
    useEffect(() => {
        if (props.open) {
            setConfettiActive(false);
            setTimeout(() => setConfettiActive(true), 100); // short delay to retrigger
            refetch();
        } else {
            setConfettiActive(false);
        }
    }, [props.open, refetch]);

    // Render modal always, show skeletons for loading fields
    return (
        <Dialog open={props.open} fullScreen>
            <Stack p={7} sx={{overflow: 'hidden', height: '100%', textAlign: 'center', justifyContent: 'space-between', alignItems: 'stretch', backgroundImage: `url(${CongratsModalBG})`, backgroundSize: '100% 100%', backgroundRepeat: 'no-repeat'}}>
                {/* Top Section: Confetti and Thank You */}
                <Stack flex={2} alignItems="center" justifyContent="center" textAlign="center">
                    <Confetti active={confettiActive} config={confettiConfig} />
                </Stack>

                {/* Middle Section: Feedback Text */}
                <Stack flex={3} alignItems="center" justifyContent="center" textAlign="center">
                    {isLoadingSummary ? (
                        <Skeleton variant="text" width={220} height={32} sx={{ fontSize: '18px', margin: '0 auto' }} />
                    ) : (
                        <Typography variant='bold' sx={{fontSize: '18px', letterSpacing: '1.2px'}}>Thank you, Dr. {summary?.reviewer_last_name}!</Typography>
                    )}
                    <DialogContentText>
                        Your feedback helps improve pack efficiency and reduce surgical waste.
                    </DialogContentText>
                </Stack>

                {/* Bottom Section: Packs Reviewed and Buttons */}
                <Stack flex={3} spacing={2} alignItems='center' justifyContent='center' textAlign='center' width={{xs: '100%', sm: '70%', md: '50%'}} sx={{ mx: 'auto' }}>
                    <Typography variant='normal' sx={{fontSize: '14px', color: `${theme.palette.text.main}` }}>
                        Packs Reviewed
                    </Typography>
                    {isLoadingSummary ? (
                        <Skeleton variant="text" width={120} height={28} sx={{ fontSize: '16px', margin: '0 auto', pb: 2 }} />
                    ) : (
                        <Typography variant='bold' sx={{fontSize: '16px', letterSpacing: '1.2px', pb: 2}}>{summary?.packs_submitted_count} of {summary?.packs_total_count}</Typography>
                    )}
                    <Button variant='blueContained' fullWidth onClick={props.handleReturnToPacks}>
                        All Packs
                    </Button>
                    <Button onClick={handleCloseModal} fullWidth variant='text'>
                        <DialogContentText>
                            Return to pack
                        </DialogContentText>
                    </Button>
                </Stack>
            </Stack>
        </Dialog>
    );
}

export default CompleteModal;